module.exports = __webpack_public_path__ + "img/image37.cb7292a3.png";